import { createSelector } from 'reselect';
import { getEntry } from 'conversations-async-data/indexed-async-data/operators/getters';
import getContacts from './getContacts';
const getThreadIdFromProps = (_, {
  threadId
}) => threadId;
export const getAsyncContact = createSelector([getContacts, getThreadIdFromProps], (indexedContacts, threadId) => getEntry(threadId, indexedContacts));